import React from 'react';
import Axios from 'axios';
import ScoresheetsList from './ScoresheetsList';
import ScoresheetEdit from './ScoresheetEdit';

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

class ScoresheetsNav extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
	  	scoresheetPageSelect: "LIST",
      scoresheetEditId: '0',
		};
	
		this.newScoresheet = this.newScoresheet.bind(this);
		this.listScoresheets = this.listScoresheets.bind(this);
		this.editScoresheet = this.editScoresheet.bind(this);
		this.renderScoresheetComponent = this.renderScoresheetComponent.bind(this);
	}

  UNSAFE_componentWillReceiveProps(nextProps) {	
		// console.log('ScoresheetNav: UNSAFE_componentWillReceiveProps')
		// console.log(nextProps);
		this.setState({
			scoresheetPageSelect: "LIST",	/*nextProps.scoresheetPageSelect*/
		});
  }

	newScoresheet() {
		this.setState({
			scoresheetEditId: '0',
			scoresheetPageSelect: "EDIT"
		});
	}

	listScoresheets() {
		this.setState({
			scoresheetPageSelect: "LIST"
		});
	}

	editScoresheet(scoresheetEditId) {
		this.setState({
			scoresheetEditId: scoresheetEditId,
			scoresheetPageSelect: "EDIT"
		});
	}

	render() {
		// console.log('ScoresheetNav: RENDER');
		// console.log(this.props)
    // console.log(this.props.season._id);

		// MAINTENANCE MESSAGE TO PREVENT MODIFICATIONS
		// return (
		//	<p>Section en maintenance, revenez un peu plus tard svp</p>
		//);

    // ADMIN LEVEL REQUESTED:  03-SEASON
    // if (this.props.adminAccess.adminValidatedAccessLevel > ADMIN_LVL_SEASONS) {

    // ADMIN LEVEL REQUESTED:  10-SCORESHEETS
    if (this.props.adminAccess.adminValidatedAccessLevel > ADMIN_LVL_SCORESHEETS) {
    	
	    return (
	      <div className="col-md-9 nopadding-left">   {/*padding-left already set in parent*/} 
	        <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
	      </div>
	    );
    } else {
			return (
				<div>
          {this.renderScoresheetComponent()}
				</div>
			);
		}
	}

	renderScoresheetComponent() {
		var isMasterAdmin = (this.props.adminAccess.adminValidatedAccessLevel === ADMIN_LVL_MASTER);
		if (this.state.scoresheetPageSelect === "LIST") {
			return (
				<div className="row">
				<div className="col-md-12">
        <input type="button" className="btn btn-primary" value="Créer une Feuille de pointage" onClick={this.newScoresheet} />
				<ScoresheetsList season={this.props.season} editScoresheet={this.editScoresheet} 
					isMasterAdmin={isMasterAdmin} /> 
				</div>
				</div>
			);
		} 
		else {
			return (
				<div className="row">
				<div className="col-md-12">
          <input type="button" className="btn btn-primary" value="Liste des Feuilles de pointage" onClick={this.listScoresheets} />
					<ScoresheetEdit season={this.props.season} scoresheetEditId={this.state.scoresheetEditId} listScoresheets={this.listScoresheets} />
				</div>
				</div>
			);
		}
	}

}

export default ScoresheetsNav;